import React, { useState } from "react";
import {useDispatch} from "react-redux";
import {useToasts} from "react-toast-notifications";

import {sendLifehouseReminder} from "../../../../store/actions/admission";
import loadingGif from '../../../../assets/images/loader.gif';

const LifehouseAdmissionReminder = ({admission}) => {
    const {addToast} = useToasts();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const handleSendReminder = () => {
        setIsLoading(true);
        dispatch(sendLifehouseReminder(admission, addToast))
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <a className={`dropdown-item pointer ${isLoading ? 'disabled' : ''}`} 
           onClick={!isLoading ? handleSendReminder : undefined}>
            {isLoading ? (
                <><img src={loadingGif} alt="Loading" /> [Test IMP-344] Lifehouse admission reminder rules</>
            ) : (
                '[Test IMP-344] Lifehouse admission reminder rules'
            )}
        </a>
    );
}

export default LifehouseAdmissionReminder; 